import HomePage from '@/views/HomePage'
import UpcomingEventsPage from '@/views/UpcomingEventsPage'
import NewsPage from '@/views/NewsPage'
import Personalities from '@/views/Personalities'
import AllNewsPage from '@/views/AllNewsPage.vue'
import AllPersonalitiesPage from '@/views/AllPersonalitiesPage.vue'
import AuthorizationPage from '@/views/AuthorizationPage.vue'
import AllConferencesPage from '@/views/AllConferencesPage.vue'
import ConferencePage from '@/views/ConferencePage.vue'
import ResourcesPage from '@/views/ResourcesPage.vue'
import LibraryPage from '@/views/LibraryPage.vue'
import ErrorPage from '@/views/ErrorPage.vue'
import AllPartners from '@/views/AllPartners.vue'
import AboutRAAIPage from '@/views/about-raai/AboutRAAIPage.vue'
import RAAIGoalsPage from '@/views/about-raai/RAAIGoalsPage.vue'
import RAAIMembers from '@/views/about-raai/RAAIMembers.vue'
import RAAIRegionalBranches from '@/views/about-raai/RAAIRegionalBranches.vue'
import OurLossesPage from '@/views/about-raai/OurLossesPage.vue'
import OurLossPage from '@/views/about-raai/OurLossPage.vue'
import ResetPasswordPage from '@/views/ResetPasswordPage.vue'
import AboutRaaiSubpage from '@/views/about-raai/AboutRaaiSubpage.vue'

const routes = [
    {
        path: '/',
        name: 'Home',
        component: HomePage
    },
    {
        path: '/news_page/:id',
        name: 'NewsPage',
        component: NewsPage,
        meta: {
            breadcrumbs: [
                {
                    title: 'Главная',
                    href: '/',
                    params: []
                },
                {
                    title: 'Новости',
                    href: '/upcoming_events',
                    params: []
                }
            ]
        }
    },
    {
        path: '/upcoming_events',
        name: 'UpcomingEventsPage',
        component: UpcomingEventsPage,
        meta: {
            breadcrumbs: [
                {
                    title: 'Главная',
                    href: '/',
                    params: []
                },
                {
                    title: 'Мероприятия',
                    href: '/upcoming_events',
                    params: []
                }
            ]
        }
    },
    {
        path: '/all_personalities',
        name: 'AllPersonalities',
        component: AllPersonalitiesPage,
        meta: {
            breadcrumbs: [
                {
                    title: 'Главная',
                    href: '/',
                    params: []
                },
                {
                    title: 'Персоналии',
                    href: '/all_personalities',
                    params: []
                }
            ]
        }
    },
    {
        path: '/authorization',
        name: 'Authorization',
        component: AuthorizationPage
    },
    {
        path: '/reset_password/:token',
        name: 'ResetPasswordPage',
        component: ResetPasswordPage
    },
    {
        path: '/personalities/:id',
        name: 'Personalities',
        component: Personalities
    },
    {
        path: '/all_news_page',
        name: 'AllNewsPage',
        component: AllNewsPage,
        meta: {
            breadcrumbs: [
                {
                    title: 'Главная',
                    href: '/',
                    params: []
                },
                {
                    title: 'Новости',
                    href: '/all_news_page',
                    params: []
                }
            ]
        }
    },
    {
        path: '/all_conferences',
        name: 'AllConferences',
        component: AllConferencesPage,
        meta: {
            breadcrumbs: [
                {
                    title: 'Главная',
                    href: '/',
                    params: []
                },
                {
                    title: 'Конференции и семинары',
                    href: '/all_conferences',
                    params: []
                }
            ]
        }
    },
    {
        path: '/conference/:id',
        name: 'Conference',
        component: ConferencePage,
        meta: {
            breadcrumbs: [
                {
                    title: 'Главная',
                    href: '/',
                    params: []
                },
                {
                    title: 'Конференции и семинары',
                    href: '/all_conferences',
                    params: []
                }
            ]
        }
    },
    {
        path: '/resources',
        name: 'ResourcesPage',
        component: ResourcesPage,
        meta: {
            breadcrumbs: [
                {
                    title: 'Главная',
                    href: '/',
                    params: []
                },
                {
                    title: 'Ресурсы',
                    href: '/resources',
                    params: []
                }
            ]
        }
    },
    {
        path: '/library',
        name: 'LibraryPage',
        component: LibraryPage,
        meta: {
            breadcrumbs: [
                {
                    title: 'Главная',
                    href: '/',
                    params: []
                },
                {
                    title: 'Библиотека',
                    href: '/library',
                    params: []
                }
            ]
        }
    },{
        path: '/error',
        name: 'ErrorPage',
        component: ErrorPage,
    },
    {
        path: '/all_partners',
        name: 'AllPartnersPage',
        component: AllPartners,
        meta: {
            breadcrumbs: [
                {
                    title: 'Главная',
                    href: '/',
                    params: []
                },
                {
                    title: 'Партнеры',
                    href: '/all_partners',
                    params: []
                }
            ]
        }
    },
    {
        path: '/about',
        name: 'AboutRAAIPage',
        component: AboutRAAIPage,
        meta: {
            breadcrumbs: [
                {
                    title: 'Главная',
                    href: '/',
                    params: []
                },
                {
                    title: 'О РАИИ',
                    href: '/about',
                    params: []
                }
            ]
        },
        children: [
            {
                path: ':mainLinkId/:subLinkId',
                component: AboutRaaiSubpage,
                name: 'aboutRaaiSubpage'
            },
            {
                path: '',
                redirect: '/about/raai_goals',
                name: 'RAIIGoals'
            },
            {
                path: 'raai_goals',
                component: RAAIGoalsPage,
                name: 'RAIIGoals2'
            },
            {
                path: 'raai_members',
                component: RAAIMembers,
                name: RAAIMembers
            },
            {
                path: 'raai_regional_branches/:subLink',
                component: RAAIRegionalBranches,
                name: RAAIRegionalBranches
            },
            {
                path: 'our_losses',
                component: OurLossesPage,
                name: OurLossesPage
            },
            {
                path: 'our_losses/:id',
                component: OurLossPage,
                name: OurLossPage
            }
        ]
    }
]

export default routes
